export default {"src":"/_next/static/image/public/images/flags/flag_592.3b516de61f072340c12e7d2b2d8dac22.svg","height":16,"width":24};